/**
 * The sound catalog: the fixed set of bundled click sounds the user can
 * choose from. Each entry has a stable id (used for persistence, so it must
 * never change), the wav file it loads from, and a friendly display name.
 */ const $458652639d27e1aa$export$86f376722808d38b = [
    {
        id: 'click',
        name: 'Click',
        file: 'assets/click.wav'
    },
    {
        id: 'noise_click',
        name: 'Noise Click',
        file: 'assets/noise_click.wav'
    },
    {
        id: 'sine_1',
        name: 'Sine 1',
        file: 'assets/sine_1.wav'
    },
    {
        id: 'sine_2',
        name: 'Sine 2',
        file: 'assets/sine_2.wav'
    },
    {
        id: 'wood_1',
        name: 'Wood 1',
        file: 'assets/wood_1.wav'
    },
    {
        id: 'wood_2',
        name: 'Wood 2',
        file: 'assets/wood_2.wav'
    }
];
const $458652639d27e1aa$export$eb5f9c6e38f3e159 = 'noise_click';
const $458652639d27e1aa$export$67fdbea1e102c657 = 'click';
function $458652639d27e1aa$export$d50e2d36029e4cac(value) {
    return typeof value === 'string' && $458652639d27e1aa$export$86f376722808d38b.some((sound)=>sound.id === value);
}
/**
 * Coerce a persisted value to a valid sound id, falling back to the default
 * when it is missing or no longer in the catalog.
 */ function $458652639d27e1aa$export$8bcf5b6f3ecd9d6d(value, fallback) {
    return $458652639d27e1aa$export$d50e2d36029e4cac(value) ? value : fallback;
}
function $458652639d27e1aa$export$16378f75946b63b2(id) {
    return $458652639d27e1aa$export$86f376722808d38b.find((sound)=>sound.id === id)?.name ?? id;
}


class $fa841c1793d902d6$export$ce4d7b336b893c95 {
    audioContext = new AudioContext();
    // we need this in the chain so that we can silence any scheduled clicks
    // when `stop()` is called
    gainNode;
    get currentTime() {
        return this.audioContext.currentTime;
    }
    buffers = new Map();
    primarySound;
    secondarySound;
    silentBuffer;
    hasClickBuffers;
    constructor(primarySound, secondarySound){
        this.primarySound = primarySound;
        this.secondarySound = secondarySound;
        this.silentBuffer = this.audioContext.createBuffer(1, 1, 44100);
        this.hasClickBuffers = Promise.all((0, $458652639d27e1aa$export$86f376722808d38b).map((sound)=>this.fetchWavAsBuffer(sound.file).then((buffer)=>this.buffers.set(sound.id, buffer))));
        this.gainNode = new GainNode(this.audioContext);
        this.gainNode.connect(this.audioContext.destination);
    }
    async resume() {
        await this.audioContext.resume().then(()=>this.hasClickBuffers);
    }
    /**
     * Swap the sound used for downbeat clicks. Applies live, to clicks
     * scheduled from this point on.
     */ setPrimarySound(sound) {
        this.primarySound = sound;
    }
    /**
     * Swap the sound used for non-downbeat clicks. Applies live, to clicks
     * scheduled from this point on.
     */ setSecondarySound(sound) {
        this.secondarySound = sound;
    }
    /**
     * Play a sound immediately, connected straight to the destination -
     * bypassing the scheduled-click gain node, which is silenced on `stop()`.
     * Safe to call whether or not the metronome is playing.
     */ async preview(sound) {
        await this.resume();
        const buffer = this.buffers.get(sound);
        if (!buffer) return;
        const source = this.audioContext.createBufferSource();
        source.buffer = buffer;
        source.connect(this.audioContext.destination);
        source.start();
    }
    /**
     * Silence any already-scheduled audio
     */ stop() {
        // reduce to silence
        this.gainNode.gain.linearRampToValueAtTime(0, this.audioContext.currentTime);
        this.gainNode.disconnect();
        // recreate
        this.gainNode = new GainNode(this.audioContext);
        this.gainNode.connect(this.audioContext.destination);
    }
    click(timestamp, clickType) {
        const click = this.audioContext.createBufferSource();
        switch(clickType){
            case 'primary':
                {
                    const buffer = this.buffers.get(this.primarySound);
                    if (buffer) click.buffer = buffer;
                    break;
                }
            case 'secondary':
                {
                    const buffer = this.buffers.get(this.secondarySound);
                    if (buffer) click.buffer = buffer;
                    break;
                }
            case "silent":
                click.buffer = this.silentBuffer;
                break;
        }
        click.connect(this.gainNode);
        click.start(timestamp);
    }
    async fetchWavAsBuffer(url) {
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        return await this.audioContext.decodeAudioData(arrayBuffer);
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};




function $9f4cd17d3bfb739b$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}




function $df5c9cb6183aeff9$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $7e50a408673c5151$export$c9648b76fd580c34 = (0, $df5c9cb6183aeff9$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $a53e47be1b60c3c3$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $b1d1a261220cb194$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $8e874a2fb001c377$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $7e50a408673c5151$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $8e874a2fb001c377$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $b1d1a261220cb194$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $7e50a408673c5151$export$c9648b76fd580c34)) errors = (0, $8e874a2fb001c377$export$1216008129fb82ed)((0, $8e874a2fb001c377$export$1216008129fb82ed)([], (0, $8e874a2fb001c377$export$8d051b38c9118094)(errors)), (0, $8e874a2fb001c377$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $7e50a408673c5151$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $b1d1a261220cb194$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $a53e47be1b60c3c3$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $a53e47be1b60c3c3$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $b1d1a261220cb194$export$610f9c3ca1a38dd8 = $b1d1a261220cb194$export$f55210826850c514.EMPTY;
function $b1d1a261220cb194$export$4f9221cbada3c4fc(value) {
    return value instanceof $b1d1a261220cb194$export$f55210826850c514 || value && 'closed' in value && (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(value.remove) && (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(value.add) && (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $b1d1a261220cb194$var$execFinalizer(finalizer) {
    if ((0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $130e6ab1a4f4ab41$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $54e99c791bb8207c$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $54e99c791bb8207c$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $8e874a2fb001c377$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $8e874a2fb001c377$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $54e99c791bb8207c$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $0b985c2ba288a978$export$ebf645db02d3e99f(err) {
    (0, $54e99c791bb8207c$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $130e6ab1a4f4ab41$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $09d0e01f28fdde08$export$8793edee2d425525() {}


var $fdc189fd52d09f69$export$b7f97edb34bc1f87 = function() {
    return $fdc189fd52d09f69$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $fdc189fd52d09f69$export$dd472c3d8fe5a85a(error) {
    return $fdc189fd52d09f69$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $fdc189fd52d09f69$export$ff9346b0d1d30313(value) {
    return $fdc189fd52d09f69$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $fdc189fd52d09f69$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $db83674f177e2fa2$var$context = null;
function $db83674f177e2fa2$export$d974811edc77eafa(cb) {
    if ((0, $130e6ab1a4f4ab41$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$db83674f177e2fa2$var$context;
        if (isRoot) $db83674f177e2fa2$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $db83674f177e2fa2$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $db83674f177e2fa2$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $db83674f177e2fa2$export$3e205fbb5df021e0(err) {
    if ((0, $130e6ab1a4f4ab41$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $db83674f177e2fa2$var$context) {
        $db83674f177e2fa2$var$context.errorThrown = true;
        $db83674f177e2fa2$var$context.error = err;
    }
}


var $a21822406e53a1a5$export$60959659b2c22881 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $b1d1a261220cb194$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $a21822406e53a1a5$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $a21822406e53a1a5$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $a21822406e53a1a5$var$handleStoppedNotification((0, $fdc189fd52d09f69$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $a21822406e53a1a5$var$handleStoppedNotification((0, $fdc189fd52d09f69$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $a21822406e53a1a5$var$handleStoppedNotification((0, $fdc189fd52d09f69$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $b1d1a261220cb194$export$f55210826850c514));
var $a21822406e53a1a5$var$_bind = Function.prototype.bind;
function $a21822406e53a1a5$var$bind(fn, thisArg) {
    return $a21822406e53a1a5$var$_bind.call(fn, thisArg);
}
var $a21822406e53a1a5$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $a21822406e53a1a5$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $a21822406e53a1a5$var$handleUnhandledError(error);
        }
        else $a21822406e53a1a5$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $a21822406e53a1a5$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $a21822406e53a1a5$export$94eeb6a328cab6c7 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $130e6ab1a4f4ab41$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $a21822406e53a1a5$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $a21822406e53a1a5$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $a21822406e53a1a5$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $a21822406e53a1a5$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($a21822406e53a1a5$export$60959659b2c22881);
function $a21822406e53a1a5$var$handleUnhandledError(error) {
    if ((0, $130e6ab1a4f4ab41$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $db83674f177e2fa2$export$3e205fbb5df021e0)(error);
    else (0, $0b985c2ba288a978$export$ebf645db02d3e99f)(error);
}
function $a21822406e53a1a5$var$defaultErrorHandler(err) {
    throw err;
}
function $a21822406e53a1a5$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $130e6ab1a4f4ab41$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $54e99c791bb8207c$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $a21822406e53a1a5$export$88d395d20619a0af = {
    closed: true,
    next: (0, $09d0e01f28fdde08$export$8793edee2d425525),
    error: $a21822406e53a1a5$var$defaultErrorHandler,
    complete: (0, $09d0e01f28fdde08$export$8793edee2d425525)
};



var $fb5600b8b605d96c$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();


function $d1675d7b83173212$export$f0954fd7d5368655(x) {
    return x;
}


function $f9bfc0ec752e7991$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $f9bfc0ec752e7991$export$71f88a61afaa14d7(fns);
}
function $f9bfc0ec752e7991$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $d1675d7b83173212$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $c3941cf54d4aa4ba$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $c3941cf54d4aa4ba$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $a21822406e53a1a5$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $db83674f177e2fa2$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $c3941cf54d4aa4ba$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $a21822406e53a1a5$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $fb5600b8b605d96c$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $f9bfc0ec752e7991$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $c3941cf54d4aa4ba$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $c3941cf54d4aa4ba$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $130e6ab1a4f4ab41$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $c3941cf54d4aa4ba$var$isObserver(value) {
    return value && (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(value.next) && (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(value.error) && (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(value.complete);
}
function $c3941cf54d4aa4ba$var$isSubscriber(value) {
    return value && value instanceof (0, $a21822406e53a1a5$export$60959659b2c22881) || $c3941cf54d4aa4ba$var$isObserver(value) && (0, $b1d1a261220cb194$export$4f9221cbada3c4fc)(value);
}




var $05f7a3630bce7cef$export$f708eee25634bc80 = (0, $df5c9cb6183aeff9$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});




var $c9189cc69fd31ace$export$b6bbab5a9b109038 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $c9189cc69fd31ace$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $05f7a3630bce7cef$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $db83674f177e2fa2$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $8e874a2fb001c377$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $db83674f177e2fa2$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $db83674f177e2fa2$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $b1d1a261220cb194$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $b1d1a261220cb194$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $a53e47be1b60c3c3$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $c3941cf54d4aa4ba$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $c9189cc69fd31ace$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $c3941cf54d4aa4ba$export$77cea355fa80b5f4));
var $c9189cc69fd31ace$export$155189cde295587d = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $b1d1a261220cb194$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($c9189cc69fd31ace$export$b6bbab5a9b109038);


var $bd698e8115fc86c4$export$c1895ea2d519a677 = {
    now: function() {
        return ($bd698e8115fc86c4$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $6c87c6ce41031553$export$915d2682b0aa0991 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $bd698e8115fc86c4$export$c1895ea2d519a677);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $c9189cc69fd31ace$export$b6bbab5a9b109038));



function $dd48a069f37f5009$export$ebec8610810318c5(source) {
    return (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $dd48a069f37f5009$export$871731df685d7753(init) {
    return function(source) {
        if ($dd48a069f37f5009$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}




function $f91d17b1cd8d7dd0$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $f91d17b1cd8d7dd0$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $f91d17b1cd8d7dd0$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $a21822406e53a1a5$export$60959659b2c22881));



function $b0ba2d9822618ffe$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $dd48a069f37f5009$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $f91d17b1cd8d7dd0$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $d1675d7b83173212$export$f0954fd7d5368655);
}





var $3ee960211923e35c$export$e19cd5f9376f8cee = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $b1d1a261220cb194$export$f55210826850c514));



var $ccf264af78c278c5$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $ccf264af78c278c5$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $8e874a2fb001c377$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args)));
        return setInterval.apply(void 0, (0, $8e874a2fb001c377$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $ccf264af78c278c5$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $9becc74b1b373225$export$b5369ffd7cb2211b = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $ccf264af78c278c5$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $ccf264af78c278c5$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $a53e47be1b60c3c3$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $3ee960211923e35c$export$e19cd5f9376f8cee));




var $afddd99de6dafc81$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $bd698e8115fc86c4$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $49202f47f01b459a$export$4114a3ec92faa3c6 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $afddd99de6dafc81$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $afddd99de6dafc81$export$d3e54bb8584cda7c));


var $f6c4c9bd71b20294$export$8d6b71a2b178fc32 = new (0, $49202f47f01b459a$export$4114a3ec92faa3c6)((0, $9becc74b1b373225$export$b5369ffd7cb2211b));
var $f6c4c9bd71b20294$export$12af436354f1a4f7 = $f6c4c9bd71b20294$export$8d6b71a2b178fc32;



function $dd125016ed30f8c3$export$187e35932e88c15c(value) {
    return value && (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(value.schedule);
}


function $c2526ac6c756a544$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}


function $dd4b589699967386$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $f6c4c9bd71b20294$export$12af436354f1a4f7);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $dd125016ed30f8c3$export$187e35932e88c15c)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $c3941cf54d4aa4ba$export$77cea355fa80b5f4)(function(subscriber) {
        var due = (0, $c2526ac6c756a544$export$c03bb0116ee09d4b)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}





var $9a39b7dcf35b06dd$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $26d60a2a32edbe86$export$4369c812aac99591(value) {
    return (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $44b42e641422b891$export$48c0cddbc99c45c2(input) {
    return (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(input[0, $fb5600b8b605d96c$export$5ab46cbf6120b33a]);
}



function $592d8dcd5a9b21b1$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $ac4e9fb3b188f5d1$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $4646311d9288ad3b$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $4646311d9288ad3b$export$6f58e2338da23f4d = $4646311d9288ad3b$export$aa9956be4ae4fe8();



function $e9f2d015065e1e76$export$9652023d9040757(input) {
    return (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $4646311d9288ad3b$export$6f58e2338da23f4d]);
}




function $0b2d1bd226c6ae7a$export$cf4785e597badab3(readableStream) {
    return (0, $8e874a2fb001c377$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $8e874a2fb001c377$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $8e874a2fb001c377$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $8e874a2fb001c377$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $8e874a2fb001c377$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $0b2d1bd226c6ae7a$export$c088ffafdba7405f(obj) {
    return (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $efbaec1979d81ee1$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $c3941cf54d4aa4ba$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $44b42e641422b891$export$48c0cddbc99c45c2)(input)) return $efbaec1979d81ee1$export$aa3d41784b3267fa(input);
        if ((0, $9a39b7dcf35b06dd$export$1e2f57719e155213)(input)) return $efbaec1979d81ee1$export$4cb2acdbcda2c253(input);
        if ((0, $26d60a2a32edbe86$export$4369c812aac99591)(input)) return $efbaec1979d81ee1$export$60f45028237c39d1(input);
        if ((0, $592d8dcd5a9b21b1$export$edb10ab8dd75a915)(input)) return $efbaec1979d81ee1$export$e073fccf36d78cc1(input);
        if ((0, $e9f2d015065e1e76$export$9652023d9040757)(input)) return $efbaec1979d81ee1$export$dcccc29c315dd646(input);
        if ((0, $0b2d1bd226c6ae7a$export$c088ffafdba7405f)(input)) return $efbaec1979d81ee1$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $ac4e9fb3b188f5d1$export$7cbe71b9fa263484)(input);
}
function $efbaec1979d81ee1$export$aa3d41784b3267fa(obj) {
    return new (0, $c3941cf54d4aa4ba$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $fb5600b8b605d96c$export$5ab46cbf6120b33a]();
        if ((0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $efbaec1979d81ee1$export$4cb2acdbcda2c253(array) {
    return new (0, $c3941cf54d4aa4ba$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $efbaec1979d81ee1$export$60f45028237c39d1(promise) {
    return new (0, $c3941cf54d4aa4ba$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $0b985c2ba288a978$export$ebf645db02d3e99f));
    });
}
function $efbaec1979d81ee1$export$dcccc29c315dd646(iterable) {
    return new (0, $c3941cf54d4aa4ba$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $8e874a2fb001c377$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $efbaec1979d81ee1$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $c3941cf54d4aa4ba$export$77cea355fa80b5f4)(function(subscriber) {
        $efbaec1979d81ee1$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $efbaec1979d81ee1$export$b2dcb11d46e7a4ad(readableStream) {
    return $efbaec1979d81ee1$export$e073fccf36d78cc1((0, $0b2d1bd226c6ae7a$export$cf4785e597badab3)(readableStream));
}
function $efbaec1979d81ee1$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $8e874a2fb001c377$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $8e874a2fb001c377$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $8e874a2fb001c377$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}






function $49caac480e766f10$var$last(arr) {
    return arr[arr.length - 1];
}
function $49caac480e766f10$export$9ae19b645239a61b(args) {
    return (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)($49caac480e766f10$var$last(args)) ? args.pop() : undefined;
}
function $49caac480e766f10$export$29534b2f653ae592(args) {
    return (0, $dd125016ed30f8c3$export$187e35932e88c15c)($49caac480e766f10$var$last(args)) ? args.pop() : undefined;
}
function $49caac480e766f10$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $49caac480e766f10$var$last(args) === 'number' ? args.pop() : defaultValue;
}


function $71621886b6c12a6a$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $49caac480e766f10$export$9ae19b645239a61b)(inputs);
    return (0, $dd48a069f37f5009$export$871731df685d7753)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $efbaec1979d81ee1$export$6a9cfa3ebc765910)(inputs[i]).subscribe((0, $f91d17b1cd8d7dd0$export$b9e075132cc6937f)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $d1675d7b83173212$export$f0954fd7d5368655))) && (hasValue = null);
                }
            }, (0, $09d0e01f28fdde08$export$8793edee2d425525)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $f91d17b1cd8d7dd0$export$b9e075132cc6937f)(subscriber, function(value) {
            if (ready) {
                var values = (0, $8e874a2fb001c377$export$1216008129fb82ed)([
                    value
                ], (0, $8e874a2fb001c377$export$8d051b38c9118094)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $8e874a2fb001c377$export$1216008129fb82ed)([], (0, $8e874a2fb001c377$export$8d051b38c9118094)(values))) : values);
            }
        }));
    });
}


/**
 * Make a node according to the specified options
 * @param currentDepth
 * @param weight default 1
 * @param isLeaf a function used to determine whether this node should be a leaf or not
 * @param divideBy how many children to create, if isLeaf === false
 * @param isTuplet is this node being created as part of a tuplet?
 */ function $5c5efdcf554e46a7$export$270e7ba5936d3c48(currentDepth = 0, weight = 1, isLeaf, divideBy, isTuplet = false) {
    if (isLeaf(currentDepth, isTuplet)) return {
        kind: 'leaf',
        weight: weight
    };
    const subdivision = divideBy(currentDepth, weight, isTuplet);
    const children = [];
    for(let i = 0; i < subdivision; i++)children.push($5c5efdcf554e46a7$export$270e7ba5936d3c48(currentDepth + 1, 1, isLeaf, divideBy, subdivision > 2));
    return {
        kind: 'node',
        weight: weight,
        children: children
    };
}
/**
 * The sum of the `value` weights of a node's children.
 * Used to derive each child's proportional share of the parent's duration.
 *
 * @throws if the node has no children (the result would be 0 and would make
 *         any derived proportional duration NaN).
 */ function $5c5efdcf554e46a7$export$77af52294bc119da(node) {
    if (node.children.length === 0) throw new Error('RhythmNode must have at least one child');
    return node.children.reduce((sum, child)=>sum + child.weight, 0);
}
/**
 * Flattens a RhythmTree to RhythmEvents from RhythmLeaf nodes.
 *
 * Each leaf's duration is derived from its position in the weight tree and the
 * root's absolute duration. The root's own `value` is ignored. The unit of the
 * output matches the unit of `rootDuration` (seconds, beats, bars, etc.) - the
 * tree itself is unit-agnostic.
 *
 * Output is rhythm-only: it carries just `duration`. Domain concerns such as
 * rests, pitch, or articulation are a separate concern.
 *
 * @throws if a RhythmNode with no children is encountered during traversal.
 */ function $5c5efdcf554e46a7$export$bffa455ba8c619a6(node, duration) {
    if (node.kind === 'leaf') return [
        {
            duration: duration
        }
    ];
    const weight = $5c5efdcf554e46a7$export$77af52294bc119da(node);
    return node.children.flatMap((child)=>$5c5efdcf554e46a7$export$bffa455ba8c619a6(child, duration * (child.weight / weight)));
}


/**
 * Biased random integer in [min, max], centred on a target derived from
 * `biasPercent` (1 -> min, 100 -> max).
 *
 * Draws a single uniform value from a window centred on the target and
 * rounds it. The window spans the whole range mid-range and narrows towards
 * the edges, which keeps the mean on the target: for a two-value range
 * (e.g. 0..1) `max` is returned with probability `biasPercent / 100`.
 *
 * @param min
 * @param max
 * @param biasPercent - range 1..100. passing 1 (or less) always returns min, 100 (or more) always returns max
 */ function $5d8ad191c5426333$export$b4da2a2d574a34b7(min, max, biasPercent = 50) {
    if (biasPercent <= 1) return min;
    if (biasPercent >= 100) return max;
    const range = max - min;
    const target = min + range * (biasPercent / 100);
    // symmetric noise around the target; full spread mid-range, narrowing
    // towards the edges so the mean stays on the target
    const halfWidth = Math.min(range / 2, target - min + 0.5, max - target + 0.5);
    const noise = (Math.random() * 2 - 1) * halfWidth;
    return Math.min(Math.max(Math.round(target + noise), min), max);
}
/**
 * Given a range, a 'bin' count and a value, return
 * the index of the value into a bin. Useful for converting UI
 * slider ranges into discrete indexes.
 * @param min
 * @param max
 * @param count
 * @param value
 */ function $5d8ad191c5426333$export$215181f5b8457fa2(min, max, count, value) {
    if (value < min || value > max) throw new Error('value must be within range');
    // 1. Edge case: max maps to the last valid index (count - 1)
    if (value === max) return count - 1;
    const normalizedValue = value - min;
    const rangeSpan = max - min;
    return Math.floor(normalizedValue / rangeSpan * count);
}




function $5024b74c40e3eace$export$871de8747c9eaa88(project, thisArg) {
    return (0, $dd48a069f37f5009$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $f91d17b1cd8d7dd0$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}





function $780f7af860c3a5ff$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}



function $850c775404996a72$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $efbaec1979d81ee1$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $f91d17b1cd8d7dd0$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $780f7af860c3a5ff$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $f91d17b1cd8d7dd0$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(resultSelector)) return $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $5024b74c40e3eace$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $efbaec1979d81ee1$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $dd48a069f37f5009$export$871731df685d7753)(function(source, subscriber) {
        return (0, $850c775404996a72$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}



function $debde0a94a59fc2b$export$c28c8388be0ab31a(project, resultSelector) {
    return (0, $9f4cd17d3bfb739b$export$f6e2535fb5126e54)(resultSelector) ? (0, $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9)(project, resultSelector, 1) : (0, $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9)(project, 1);
}


// Partially determines possible subdivisions.
const $292cfe32faa76c70$var$MAX_DEPTH = 4;
const $292cfe32faa76c70$var$MAX_GRANULARITY = 100;
/**
 * Intention is to create a bar from a single node. Each subdivision depth should
 * be managed separately in terms of probability, so that we can ensure that subdivisions
 * like whole not triplets are less likely than quarter note triplets, for example.
 *
 * Builds a tree that allows for any number of beats per bar as the root's children.
 * Groups odd numbers into weights of 2s and 1s, which can then be subdivided.
 */ class $292cfe32faa76c70$export$b135b2512b192788 {
    settings;
    isLeaf = (currentDepth, isTuplet)=>{
        // An index into each granularity range, e.g. 0 -> 1 - 25, 1 -> 26 - 50, etc.
        // Basically divides the full granularity range (hardcoded to 100 atm), by the MAX_DEPTH, and
        // then uses the result to convert the current granularity setting into a maxDepth.
        // Then roughly converts the granularity slider into a probability, which translates
        // into how much a beat might be subdivided
        const settingsMaxDepth = (0, $5d8ad191c5426333$export$215181f5b8457fa2)(1, $292cfe32faa76c70$var$MAX_GRANULARITY, $292cfe32faa76c70$var$MAX_DEPTH, this.settings.granularity);
        const randomisedMaxDepth = (0, $5d8ad191c5426333$export$b4da2a2d574a34b7)(0, settingsMaxDepth, 50) + 1;
        // Effectively, might return a leaf even when not at max depth.
        // And don't allow nested tuplets.
        return currentDepth >= randomisedMaxDepth || isTuplet;
    };
    subdivideBy = (currentDepth)=>{
        // A 100% tuplet bias doesn't work because it means the top level always gets
        // subdivided and then nothing below it (we are not allowing nested tuplets in this algo).
        // Instead, use a combination of the tuplet bias, current depth and granularity to weight more
        // towards tuplets in smaller subdivisions, i.e. lower in the tree. If we are at max
        // tuplet bias, only the deepest level should all be tupletized.
        const settingsMaxDepth = (0, $5d8ad191c5426333$export$215181f5b8457fa2)(1, $292cfe32faa76c70$var$MAX_GRANULARITY, $292cfe32faa76c70$var$MAX_DEPTH, this.settings.granularity) + 1;
        // Set the bias based on where the currentDepth is in relation
        // to the settingsMaxDepth. Shallower -> less bias, Deeper -> more bias
        const bias = this.settings.tupletBias / settingsMaxDepth * (currentDepth + 1);
        return (0, $5d8ad191c5426333$export$b4da2a2d574a34b7)(2, 3, bias);
    };
    constructor(settings){
        this.settings = settings;
    }
    // create the top level bar structure, before delegating to the more generic createNode function
    generate() {
        // Group beatsPerBar into weights of 2s and 1s. This allows for
        // subdivisions of 2 beats at a time, which then allows for half note triplets.
        // each group represents either 1 or 2 'periods' (beats)
        const groups = this.createWeightGroups(this.settings.beatsPerBar);
        const children = groups.map((weightGroup)=>{
            // Effectively balances the depth of the tree by allowing nodes with more weight (2s)
            // to be subdivided when 1s won't get subdivided. A bit hacky, but it works.
            // An unwanted side effect is that the tree may not go deep enough for low beatsPerMinute settings.
            const newDepth = weightGroup === 1 ? 1 : 0;
            return (0, $5c5efdcf554e46a7$export$270e7ba5936d3c48)(newDepth, weightGroup, this.isLeaf, this.subdivideBy);
        });
        return {
            kind: 'node',
            weight: 1,
            children: children
        };
    }
    /**
     * Takes total weight and returns an array which groups total weight
     * into 2s and 1s, and effectively shuffles the result. For small values (1, 2, 3),
     * returns groups with only 1s.
     * @param totalWeight
     * @private
     */ createWeightGroups(totalWeight) {
        if (totalWeight <= 0) return [];
        switch(totalWeight){
            case 1:
                return [
                    1
                ];
            case 2:
                return [
                    1,
                    1
                ];
            case 3:
                return [
                    1,
                    1,
                    1
                ];
            default:
                {
                    const twos = Math.floor(totalWeight / 2);
                    const hasRemainder = totalWeight % 2 !== 0;
                    const groups = Array(twos).fill(2);
                    if (hasRemainder) {
                        const randomIndex = (0, $5d8ad191c5426333$export$b4da2a2d574a34b7)(0, groups.length);
                        groups.splice(randomIndex, 0, 1);
                    }
                    return groups;
                }
        }
    }
}
function $292cfe32faa76c70$export$abd0aca80557add2(barRequests, generator, settings) {
    return barRequests.pipe((0, $5024b74c40e3eace$export$871de8747c9eaa88)(()=>generator.generate()), (0, $debde0a94a59fc2b$export$c28c8388be0ab31a)((tree)=>(0, $5c5efdcf554e46a7$export$bffa455ba8c619a6)(tree, settings.beatsPerBar).map((rhythmEvent, index)=>({
                duration: rhythmEvent.duration,
                isRest: index === 0 && settings.hasDownbeatAlways ? false : (0, $5d8ad191c5426333$export$b4da2a2d574a34b7)(0, 1, settings.spaceBias) === 1,
                isDownbeat: index === 0
            }))));
}


/**
 * Owns bar-event generation and look-ahead scheduling of {@link Onset}s.
 *
 * Pulls {@link BarEvent}s from the demand-driven bar event stream into a
 * buffer, and every `lookAhead` milliseconds converts enough of them into
 * timestamped onsets to fill the `scheduleAheadTime` window, publishing them
 * on {@link onsets$}. Timestamps are derived from the injected audio clock,
 * so the caller decides which clock the schedule runs against.
 *
 * Durations are emitted in beats by the stream and converted to seconds here,
 * so tempo changes apply live, within the look-ahead window. Structural
 * settings take effect when the next bar is generated.
 *
 * This is deliberately pull-based (the classic Web Audio "two clocks"
 * pattern): audio scheduling must run ahead of wall-clock time, which a
 * push-based stream cannot do on its own.
 */ class $ce08bbcbda625c55$export$e35a6eeb699072ae {
    settings;
    currentTime;
    // how often to call schedule(), milliseconds
    lookAhead = 25;
    // how far ahead to schedule audio, seconds
    scheduleAheadTime = 0.1;
    schedulerSubscription;
    barRequests$ = new (0, $c9189cc69fd31ace$export$b6bbab5a9b109038)();
    barBuffer = [];
    // replays the most recent onset so the scheduler can compute the next
    // timestamp from it
    onsetStream$ = new (0, $6c87c6ce41031553$export$915d2682b0aa0991)(1);
    onsets$ = this.onsetStream$;
    scheduler$ = (0, $dd4b589699967386$export$9dc4ecf953986f04)(0, this.lookAhead).pipe((0, $71621886b6c12a6a$export$d449030e5c10edf7)(this.onsetStream$), (0, $b0ba2d9822618ffe$export$3f23594af5f37336)(([, onset])=>this.schedule(onset)));
    /**
     * Duration of one beat in seconds. Read live from settings so tempo changes
     * apply to the next scheduled onset, within the look-ahead window.
     */ get beatDuration() {
        return 60 / this.settings.bpm;
    }
    constructor(settings, currentTime){
        this.settings = settings;
        this.currentTime = currentTime;
        const generator = new (0, $292cfe32faa76c70$export$b135b2512b192788)(this.settings);
        (0, $292cfe32faa76c70$export$abd0aca80557add2)(this.barRequests$, generator, this.settings).subscribe((event)=>this.barBuffer.push(event));
    }
    /**
     * Pre-schedule the count-in (beatsPerBar evenly spaced, always sounding,
     * with the first as the downbeat) and start the look-ahead loop.
     */ start() {
        const firstTimestamp = this.currentTime() + this.scheduleAheadTime;
        for(let i = 0; i < this.settings.beatsPerBar; i++)this.onsetStream$.next({
            duration: this.beatDuration,
            timestamp: firstTimestamp + i * this.beatDuration,
            isRest: false,
            isDownBeat: i === 0
        });
        this.schedulerSubscription = this.scheduler$.subscribe();
    }
    /**
     * Stop scheduling and clear the buffered bar, so the next start begins
     * cleanly at a downbeat.
     */ stop() {
        this.schedulerSubscription?.unsubscribe();
        this.barBuffer = [];
    }
    schedule(previousOnset) {
        const onsets = [];
        let nextTimestamp = previousOnset.timestamp + previousOnset.duration;
        while(nextTimestamp < this.currentTime() + this.scheduleAheadTime){
            const nextEvent = this.nextEvent();
            const duration = nextEvent.duration * this.beatDuration;
            onsets.push({
                duration: duration,
                timestamp: nextTimestamp,
                isRest: nextEvent.isRest,
                isDownBeat: nextEvent.isDownbeat
            });
            nextTimestamp += duration;
        }
        onsets.forEach((onset)=>this.onsetStream$.next(onset));
    }
    nextEvent() {
        if (this.barBuffer.length === 0) // synchronously refills the buffer with a fresh bar
        this.barRequests$.next();
        return this.barBuffer.shift();
    }
}



/**
 * The Settings bottom sheet: slides up from the bottom of the screen, with
 * segmented Downbeat/Secondary tabs that each list the full sound catalog as
 * big touch rows (native radio inputs). One list is visible at a time, and
 * each tab echoes its current choice.
 *
 * Standard modal behaviour: focus trap, Escape and backdrop click close, and
 * focus is restored to the gear button on close.
 *
 * The markup lives in index.html; this class wires it up and renders the
 * sound rows from the catalog.
 */ class $c225fa43b3799a31$export$ee3e5af31f081424 {
    options;
    backdrop;
    sheet;
    panel;
    openButton;
    soundList;
    tabs;
    activeSection = 'downbeat';
    isOpen = false;
    lastFocused = null;
    constructor(options){
        this.options = options;
        this.backdrop = document.getElementById('settings-backdrop');
        this.sheet = document.getElementById('settings-sheet');
        this.panel = document.getElementById('settings-panel');
        this.openButton = document.getElementById('settings-open');
        this.soundList = document.getElementById('settings-sounds');
        this.tabs = Array.from(this.backdrop.querySelectorAll('.settings-tab'));
        this.openButton.addEventListener('click', ()=>this.open());
        this.backdrop.querySelector('.sheet-close').addEventListener('click', ()=>this.close());
        this.backdrop.addEventListener('click', (event)=>{
            if (event.target === this.backdrop) this.close();
        });
        this.backdrop.addEventListener('keydown', (event)=>this.onKeydown(event));
        this.tabs.forEach((tab)=>{
            tab.addEventListener('click', ()=>this.selectSection(tab.dataset.section));
        });
        this.selectSection('downbeat');
        this.syncEchoes();
    }
    open() {
        if (this.isOpen) return;
        this.isOpen = true;
        this.lastFocused = document.activeElement;
        // always reopen on the Downbeat tab
        this.selectSection('downbeat');
        this.backdrop.hidden = false;
        // add the class on the next frame so the slide-up transition runs
        requestAnimationFrame(()=>this.backdrop.classList.add('open'));
        document.body.classList.add('sheet-open');
        this.sheet.focus();
    }
    close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.backdrop.classList.remove('open');
        document.body.classList.remove('sheet-open');
        const hide = ()=>{
            if (!this.isOpen) this.backdrop.hidden = true;
        };
        this.sheet.addEventListener('transitionend', hide, {
            once: true
        });
        // fallback in case the transition is interrupted and never ends
        setTimeout(hide, 300);
        (this.lastFocused ?? this.openButton).focus();
    }
    onKeydown(event) {
        if (event.key === 'Escape') {
            event.stopPropagation();
            this.close();
            return;
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            // tablist arrow-key navigation, with automatic activation
            const target = event.target;
            if (target.classList.contains('settings-tab')) {
                event.preventDefault();
                const index = this.tabs.indexOf(target);
                const direction = event.key === 'ArrowLeft' ? -1 : 1;
                const next = this.tabs[(index + direction + this.tabs.length) % this.tabs.length];
                this.selectSection(next.dataset.section);
                next.focus();
            }
            return;
        }
        if (event.key !== 'Tab') return;
        // focus trap
        const focusables = Array.from(this.backdrop.querySelectorAll('button, input, [href], [tabindex]')).filter((el)=>!el.hasAttribute('disabled') && el.tabIndex >= 0);
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }
    /**
     * Switch the visible sound list to the given section, keeping the tab
     * states (aria-selected, roving tabindex) and the panel label in sync.
     */ selectSection(section) {
        this.activeSection = section;
        this.tabs.forEach((tab)=>{
            const isActive = tab.dataset.section === section;
            tab.classList.toggle('active', isActive);
            tab.setAttribute('aria-selected', '' + isActive);
            tab.tabIndex = isActive ? 0 : -1;
        });
        this.panel.setAttribute('aria-labelledby', `settings-tab-${section}`);
        this.soundList.setAttribute('aria-label', `${section === 'downbeat' ? 'Downbeat' : 'Secondary'} sound`);
        this.renderRows();
    }
    renderRows() {
        const selection = this.options.getSelection(this.activeSection);
        this.soundList.innerHTML = '';
        for (const sound of (0, $458652639d27e1aa$export$86f376722808d38b)){
            const row = document.createElement('label');
            row.className = 'sound-row';
            row.innerHTML = `
                <input type="radio" name="${this.activeSection}-sound" value="${sound.id}">
                <span class="sound-radio" aria-hidden="true"></span>
                <span class="sound-name">${sound.name}</span>
                <svg class="sound-check" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>`;
            const input = row.querySelector('input');
            input.checked = sound.id === selection;
            input.addEventListener('change', ()=>this.selectSound(sound.id));
            this.soundList.appendChild(row);
        }
    }
    selectSound(sound) {
        this.options.onSelect(this.activeSection, sound);
        this.echo(this.activeSection).textContent = (0, $458652639d27e1aa$export$16378f75946b63b2)(sound);
    }
    /** Refresh both tabs' current-choice echoes from the current selections. */ syncEchoes() {
        this.tabs.forEach((tab)=>{
            const section = tab.dataset.section;
            this.echo(section).textContent = (0, $458652639d27e1aa$export$16378f75946b63b2)(this.options.getSelection(section));
        });
    }
    echo(section) {
        return this.backdrop.querySelector(`#settings-tab-${section} .settings-tab-choice`);
    }
}



class $4bd60e76e585cbb1$var$Main {
    settings;
    audio;
    scheduler;
    isPlaying = false;
    constructor(){
        this.settings = this.loadSettings();
        this.initialise();
    }
    /**
     * The player is created lazily, on the first user interaction that needs
     * audio (pressing play, or picking a sound in the Settings sheet), so
     * that the AudioContext is always created inside a user gesture.
     * @private
     */ getOrCreateAudio() {
        if (!this.audio) {
            const audio = new (0, $fa841c1793d902d6$export$ce4d7b336b893c95)(this.settings.downbeatSound, this.settings.secondarySound);
            this.audio = audio;
            this.scheduler = new (0, $ce08bbcbda625c55$export$e35a6eeb699072ae)(this.settings, ()=>audio.currentTime);
            // rests and downbeats are already decided by the bar event stream;
            // the audio layer only maps them to a click type - no randomness here.
            this.scheduler.onsets$.subscribe((onset)=>{
                const clickType = onset.isRest ? 'silent' : onset.isDownBeat ? 'primary' : 'secondary';
                audio.click(onset.timestamp, clickType);
            });
        }
        return this.audio;
    }
    start() {
        this.isPlaying = true;
        this.getOrCreateAudio().resume().then(()=>this.scheduler?.start());
    }
    /**
     * A sound was picked in the Settings sheet: persist it (localStorage key
     * matches the Settings key) and swap the live click sound. Previews only
     * play while the metronome is stopped - while it is running, the next
     * scheduled click already demonstrates the new sound.
     * @private
     */ onSoundSelected(section, sound) {
        const key = section === 'downbeat' ? 'downbeatSound' : 'secondarySound';
        this.settings[key] = sound;
        localStorage.setItem(key, sound);
        const audio = this.getOrCreateAudio();
        if (section === 'downbeat') audio.setPrimarySound(sound);
        else audio.setSecondarySound(sound);
        if (!this.isPlaying) audio.preview(sound);
    }
    stop() {
        this.isPlaying = false;
        this.scheduler?.stop();
        this.audio?.stop();
    }
    /**
     * Wire up the UI listeners
     * @private
     */ initialise() {
        const playCheckbox = document.getElementById('play-checkbox');
        const playControl = document.getElementById('play-control');
        if (playCheckbox) playCheckbox.addEventListener('click', (event)=>{
            const isPlaying = event.target.checked;
            playControl.classList.toggle('playing', isPlaying);
            playControl.setAttribute('aria-label', isPlaying ? 'Stop' : 'Play');
            if (isPlaying) this.start();
            else this.stop();
        });
        this.bindNumericControl('bpm', 'bpm');
        this.makeBpmValueEditable();
        this.bindNumericControl('beatsPerBar', 'beatsPerBar');
        this.bindNumericControl('granularity', 'granularity');
        this.bindNumericControl('space', 'spaceBias');
        this.bindNumericControl('tuplets', 'tupletBias');
        this.bindBooleanControl('hasDownbeatAlways', 'hasDownbeatAlways');
        new (0, $c225fa43b3799a31$export$ee3e5af31f081424)({
            getSelection: (section)=>section === 'downbeat' ? this.settings.downbeatSound : this.settings.secondarySound,
            onSelect: (section, sound)=>this.onSoundSelected(section, sound)
        });
        this.wireHintPopovers();
    }
    /**
     * Wire up the per-control hint toggletips: click the badge to toggle its
     * popover, click anywhere else (or press Escape) to dismiss. Only one
     * popover is open at a time.
     * @private
     */ wireHintPopovers() {
        const closers = [];
        document.querySelectorAll('.hint').forEach((hint)=>{
            const toggle = hint.querySelector('.hint-toggle');
            const popover = hint.querySelector('.hint-popover');
            if (!toggle || !popover) return;
            const close = ()=>{
                popover.hidden = true;
                toggle.setAttribute('aria-expanded', 'false');
            };
            closers.push(close);
            toggle.addEventListener('click', (event)=>{
                event.stopPropagation();
                if (popover.hidden) {
                    closers.forEach((c)=>c());
                    popover.hidden = false;
                    toggle.setAttribute('aria-expanded', 'true');
                } else close();
            });
            popover.addEventListener('click', (event)=>event.stopPropagation());
            document.addEventListener('click', close);
            document.addEventListener('keydown', (event)=>{
                if (event.key === 'Escape' && !popover.hidden) {
                    close();
                    toggle.focus();
                }
            });
        });
    }
    /**
     * Bind a numeric input control to a Settings key: initialise the control
     * from settings, and on change persist to localStorage and update settings.
     * The localStorage key matches the Settings key.
     * @private
     */ bindNumericControl(id, key) {
        const control = document.getElementById(id);
        if (control) {
            control.addEventListener('change', (event)=>{
                const value = event.target.valueAsNumber;
                localStorage.setItem(key, '' + value);
                this.settings[key] = value;
            });
            control.valueAsNumber = this.settings[key];
            // sync the <output> displays wired up via the inline oninput handlers
            control.dispatchEvent(new Event('input'));
        }
    }
    /**
     * Make the big bpm readout editable: click (or Enter/Space while focused)
     * to swap it for a number input; Enter/blur commits, Escape cancels.
     * Committing updates the slider and fires its change event, reusing the
     * existing bindNumericControl path to persist and update settings.
     * @private
     */ makeBpmValueEditable() {
        const output = document.getElementById('bpm-output');
        const input = document.getElementById('bpm-input');
        const slider = document.getElementById('bpm');
        if (!output || !input || !slider) return;
        let cancelled = false;
        const startEditing = ()=>{
            input.value = output.value;
            output.hidden = true;
            input.hidden = false;
            input.focus();
            input.select();
        };
        const stopEditing = ()=>{
            input.hidden = true;
            output.hidden = false;
        };
        const commit = ()=>{
            if (!isNaN(input.valueAsNumber)) {
                const min = Number(slider.min);
                const max = Number(slider.max);
                const value = Math.min(Math.max(Math.round(input.valueAsNumber), min), max);
                output.value = '' + value;
                slider.valueAsNumber = value;
                slider.dispatchEvent(new Event('change'));
            }
            stopEditing();
        };
        output.addEventListener('click', startEditing);
        output.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                startEditing();
            }
        });
        input.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') commit();
            else if (event.key === 'Escape') {
                cancelled = true;
                stopEditing();
            }
        });
        input.addEventListener('blur', ()=>{
            // Escape hides the input, which fires blur; don't commit that
            if (cancelled) {
                cancelled = false;
                return;
            }
            commit();
        });
    }
    /**
     * Bind a checkbox control to a Settings key: initialise the control
     * from settings, and on click persist to localStorage and update settings.
     * The localStorage key matches the Settings key.
     * @private
     */ bindBooleanControl(id, key) {
        const control = document.getElementById(id);
        if (control) {
            control.addEventListener('click', (event)=>{
                const isChecked = event.target.checked;
                localStorage.setItem(key, JSON.stringify(isChecked));
                this.settings[key] = isChecked;
            });
            control.checked = this.settings[key];
        }
    }
    loadSettings() {
        return {
            bpm: +(localStorage.getItem('bpm') || 80),
            beatsPerBar: +(localStorage.getItem('beatsPerBar') || 4),
            granularity: +(localStorage.getItem('granularity') || 1),
            tupletBias: +(localStorage.getItem('tupletBias') || 1),
            minTupletDepth: 1,
            spaceBias: +(localStorage.getItem('spaceBias') || 1),
            hasDownbeatAlways: localStorage.getItem('hasDownbeatAlways') !== 'false',
            downbeatSound: (0, $458652639d27e1aa$export$8bcf5b6f3ecd9d6d)(localStorage.getItem('downbeatSound'), (0, $458652639d27e1aa$export$eb5f9c6e38f3e159)),
            secondarySound: (0, $458652639d27e1aa$export$8bcf5b6f3ecd9d6d)(localStorage.getItem('secondarySound'), (0, $458652639d27e1aa$export$67fdbea1e102c657))
        };
    }
}
new $4bd60e76e585cbb1$var$Main();
// Offline support (PWA). Production builds only: the service worker is
// generated into dist/ by scripts/generate-sw.cjs, and registering it against
// the dev server would fight hot reload.
if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    // indirection so Parcel doesn't try to bundle the worker as an asset -
    // it only exists in dist/ after the Workbox step
    const serviceWorkerUrl = 'service-worker.js';
    navigator.serviceWorker.register(serviceWorkerUrl).catch((error)=>console.warn('Service worker registration failed:', error));
});


//# sourceMappingURL=clicker.37b90362.js.map
